import React from 'react'

import withConfig  from '../../../../../../contexts/config/withConfig'
import withDialogs from '../../../../../../contexts/dialogs/withDialogs'
import withi18n    from '../../../../../../contexts/i18n/withi18n'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import blueGrey from '@material-ui/core/colors/blueGrey'

import { FaBriefcaseMedical } from 'react-icons/fa'

import ChipsContainer, { styles } from '../../../../../containers/ChipsContainer'

import generify from '../../../../../../things/generify'

import AnnualHealthReview from '../../../../../../things/livestock/reviews/AnnualHealthReview'
import Sector             from '../../../../../../things/Sector'
import SectorHealthEvent  from '../../../../../../things/livestock/events/SectorHealthEvent'
import Thing              from '../../../../../../things/Thing'
import Word               from '../../../../../../things/Word'

const css = () => (
{
    ...styles,
    chip :
    {
        backgroundColor : blueGrey[100],
        margin          : 8
    }
});

class Causes extends ChipsContainer
{
    getEntry = init =>
    {
        const { subjectOf } = this.props ;

        let empty = {} ;

        if( init instanceof Thing )
        {
            empty = init.toObject() ;
        }
        else if( init )
        {
            empty = { ...init } ;
        }

        return new SectorHealthEvent( { ...empty , subjectOf } ) ;
    };

    getLocale = () => this.props.locale.things.livestock.reviews.annual.medical.causes ;

    getThing = () =>
    {
        const { thing } = this.props ;
        if( thing )
        {
            const { hypothesis } = thing ;
            return hypothesis ;
        }
        return null ;
    };

    editInit = ( item ) =>
    {
        if( item )
        {
            const { hypothesis } = item ;
            if( hypothesis )
            {
                const { causes } = hypothesis ;
                if( causes instanceof Array )
                {
                    return causes.map( element =>
                    {
                        if( element instanceof Word )
                        {
                            return element.clone() ;
                        }
                        return null ;
                    })
                }
            }
        }
        return null ;
    };

    onEdit = ( item ) =>
    {
        const { onChange } = this.props ;
        if( onChange )
        {
            onChange( item ) ;
        }
    };

    editPrepare = ( datas , props ) =>
    {
        const { item:current } = props ;
        if( current instanceof SectorHealthEvent )
        {
            let {
                id:key,
                subjectOf:review
            }
            = current ;

            if( review instanceof AnnualHealthReview )
            {
                review = review.toObject() ;

                const { about } = current ;
                if( about instanceof Sector )
                {
                    const { id } = about ;
                    if( id )
                    {
                        let { subReview } = review ;
                        if( subReview instanceof Array )
                        {
                            let len1 = subReview.length ;
                            for( let i = 0 ; i<len1 ; i++ )
                            {
                                let workplace = subReview[i] ;
                                if( workplace )
                                {
                                    let { subReview } = workplace ;
                                    if( subReview instanceof Array )
                                    {
                                        let len2 = subReview.length ;
                                        for( let j = 0 ; j<len2 ; j++  )
                                        {
                                            let sector = subReview[j] ;
                                            if( sector )
                                            {
                                                let { about } = sector ;
                                                if( about )
                                                {
                                                    let { id:index } = about ;
                                                    if( index === id )
                                                    {
                                                        const { events } = sector ;
                                                        if( events instanceof Array )
                                                        {
                                                            let len3 = events.length ;
                                                            for( let z = 0 ; z<len3 ; z++ )
                                                            {
                                                                let event = events[z] ;
                                                                if( event )
                                                                {
                                                                    const { id } = event ;
                                                                    if( key === id )
                                                                    {
                                                                        const { hypothesis } = event ;
                                                                        if( hypothesis )
                                                                        {
                                                                            if( datas )
                                                                            {
                                                                                if( datas instanceof Array && datas.length === 0 )
                                                                                {
                                                                                    datas = null ;
                                                                                }
                                                                                datas = generify(datas,true) ;
                                                                            }
                                                                            hypothesis.causes = datas ;
                                                                        }
                                                                        review = JSON.stringify(review) ;
                                                                        return { review } ;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return null ;
    };
}

Causes.defaultProps =
{
    ...ChipsContainer.defaultProps ,
    chipVariant : 'default' ,
    icon        : <FaBriefcaseMedical size={18}/>,
    member      : 'causes'
};

Causes.propTypes =
{
    ...ChipsContainer.propTypes
};

export default withStyles( css ) ( withRouter( withConfig( withi18n( withDialogs( Causes ) ) ) ) ) ;
